import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { TrackingScreen } from "@/features/user/tracking-screen"
import type { OrderTracking } from "@/features/user/types"

type Props = {
  order: OrderTracking
}

export default function UserOrdersShow() {
  const { order } = usePage<Props>().props

  return (
    <UserLayout>
      <TrackingScreen order={order} />
    </UserLayout>
  )
}
